import { render, staticRenderFns } from "./PagePositionTemplateEdit.vue?vue&type=template&id=cb368412&"
import script from "./PagePositionTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./PagePositionTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports